// extracted by mini-css-extract-plugin
module.exports = {"title-container":"OrderDetailsHeader_title-container__1OccQ","title":"OrderDetailsHeader_title__3ChLS","date":"OrderDetailsHeader_date__3C47m"};